import React, {useEffect, useState} from 'react'
import {Box, Button, HStack, Image, VStack, CloseButton, Text} from '@chakra-ui/react3'
import {FormattedMessage, useIntl} from 'react-intl'
import PropTypes from 'prop-types'
import useProductSpecialOffers from '../../../../hooks/use-product-special-offers'
import {ChevronDownIcon, ChevronUpIcon} from '../../../../leap/components/icons'

const PromotionBanner = ({product}) => {
    const {formatMessage} = useIntl()
    const [isOpen, setIsOpen] = useState(false)
    const [isVisible, setIsVisible] = useState(true)
    const [isIconURLValid, setIsIconURLValid] = useState(true)

    const {promotions, loading} = useProductSpecialOffers(product, null, 'xpdp')

    const promotion = promotions?.[0]

    const textColor = '#26445A'

    // Reset the banner visibility and icon validation when the active promotion changes
    useEffect(() => {
        setIsVisible(true)
        setIsIconURLValid(true)
    }, [promotion?.id])

    if (loading || !promotion || !isVisible) return null

    return (
        <Box
            as="section"
            aria-label={formatMessage({
                id: 'leap.promotion.assistive_msg.section_label',
                defaultMessage: 'promotion'
            })}
            width="full"
            position="relative"
            backgroundColor="#C9E8F2"
            color={textColor}
            paddingBlock={'spacing-8'}
            paddingInline={{base: 'spacing-24', s: 'spacing-32'}}
        >
            <CloseButton
                size="sm"
                onClick={() => setIsVisible(false)}
                aria-label={formatMessage({
                    id: 'leap.promotion.assistive_msg.dismiss_promotion',
                    defaultMessage: 'dismiss promotion'
                })}
                top="spacing-8"
                right="spacing-8"
                position="absolute"
                color={textColor}
            />

            <VStack align="start" width="full" gap="spacing-8">
                <HStack gap="spacing-8" align="center">
                    {promotion?.c_promotionIcon && isIconURLValid && (
                        <Image
                            alt=""
                            src={promotion.c_promotionIcon}
                            boxSize={4}
                            flexShrink={0}
                            onError={() => setIsIconURLValid(false)}
                        />
                    )}
                    <Text textStyle="md">{promotion.name}</Text>
                </HStack>

                <Text lineClamp={isOpen ? undefined : 1} textStyle="sm">
                    {promotion.calloutMsg}
                </Text>

                {isOpen && promotion.details && (
                    <Box textStyle="sm">
                        <Text>{promotion.details}</Text>
                    </Box>
                )}

                {promotion.details && (
                    <Button
                        textDecoration="underline"
                        color={textColor}
                        paddingInline={0}
                        textUnderlineOffset={4}
                        size="sm"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <span>
                            {isOpen ? (
                                <FormattedMessage
                                    id="leap.promotion.show_less"
                                    defaultMessage="Show less"
                                />
                            ) : (
                                <FormattedMessage
                                    id="leap.promotion.show_more"
                                    defaultMessage="Show more"
                                />
                            )}
                        </span>
                        {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    </Button>
                )}
            </VStack>
        </Box>
    )
}

PromotionBanner.propTypes = {
    product: PropTypes.object
}

export default PromotionBanner
